import { storages } from './browserStorage'

export function getRefreshTokenFromStorage() {
	return storages.local.getItem('refresh_token')
}
